<template>
  <section class="cookie-banner-wrapper" v-if="isShowCookieBanner">
    <div class="left">
      <i18n-t class="cookie-desc" keypath="cookie-banner-desc" tag="p">
        <router-link to="/privacypolicy" target="_blank" class="tc-link">{{
          $t('privacy')
        }}</router-link>
      </i18n-t>
    </div>
    <div class="right">
      <button class="accept-btn" aria-roledescription="accept cookie" @click="acceptCookieBanner">
        {{ $t('accept') }}
      </button>
    </div>
    <div class="close-icon" @click="closeCookieBanner"></div>
  </section>
</template>

<script>
  import { mapState } from 'vuex';
  import store from '@/store';

  export default {
    name: 'CookieBanner',
    methods: {
      acceptCookieBanner() {
        store.commit('setState', {
          state: 'isShowCookieBanner',
          values: false,
        });
        localStorage.setItem('isShowCookieBanner', JSON.stringify(false));
      },
      closeCookieBanner() {
        store.commit('setState', {
          state: 'isShowCookieBanner',
          values: false,
        });
        localStorage.setItem('isShowCookieBanner', JSON.stringify(true));
      },
    },
    computed: {
      ...mapState(['isShowCookieBanner']),
    },
  };
</script>

<style lang="scss" scoped>
  @use 'index';
</style>
